"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendWorksheet = void 0;
function appendWorksheet(worksheet, targetWorkbook) {
    const index = targetWorkbook.worksheets.length + 1;
    const originalWorkbook = worksheet.workbook;
    targetWorkbook.addWorksheet("Sheet");
    targetWorkbook._worksheets[index] = worksheet;
    worksheet.id = index;
    worksheet._workbook = targetWorkbook;
    worksheet.orderNo = index;
    targetWorkbook.model.media.push(...originalWorkbook.model.media);
}
exports.appendWorksheet = appendWorksheet;
//# sourceMappingURL=excelUtil.js.map